import React from 'react';
import styled from 'styled-components';

// COMPONENTS
import Image from '../../common/Image/Image';
import HermesIconSelector from '../../../../../shared/components/HermesIconSelector';

// STYLES
import * as S from './SocialPersuasion.styles';

// ICONS
import TwoPeopleIcon from '../../../../Icons/TwoPeopleIcon';

// THEME
import {defaultTheme} from '@stencil/build-theme';

interface SocialPersuasionUIProp {
  text?: string;
  colors?: {
    background?: string;
    text?: string;
  };
}

const SocialAvatarImage = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 50%;
`;

const SocialPersuasionUI: React.FC<{
  persuasionHeadingData: SocialPersuasionUIProp;
  friendsPersuasionData: SocialPersuasionUIProp;
  imageUrl: string;
}> = ({persuasionHeadingData, friendsPersuasionData, imageUrl}) => {
  if (!(persuasionHeadingData && friendsPersuasionData)) {
    return null;
  }

  const imagePresent = !!imageUrl;

  return (
    <S.Container>
      <S.InnerWrap>
        <S.ContentWrap>
          <S.ImageContainer imagePresent={imagePresent}>
            {imagePresent ? (
              <SocialAvatarImage src={imageUrl} alt="social contact image" />
            ) : (
              <HermesIconSelector
                name="tSocial"
                styleProps={{
                  transform: 'scale(2)',
                }}
              />
            )}
          </S.ImageContainer>

          <S.ContentTextWrapper>
            <S.FriendsStayedTextContainer background={persuasionHeadingData?.colors?.background}>
              <TwoPeopleIcon fill={defaultTheme.colors.goWhite.base} transform="scale(0.7)" />
              <S.FriendsStayedText
                textColor={persuasionHeadingData?.colors?.text}
                backgroundColor={persuasionHeadingData?.colors?.background}
              >
                {persuasionHeadingData.text}
              </S.FriendsStayedText>
            </S.FriendsStayedTextContainer>
            <S.FriendPersuasionText
              textColor={friendsPersuasionData?.colors?.text}
              backgroundColor={friendsPersuasionData?.colors?.background}
            >
              {friendsPersuasionData.text}
            </S.FriendPersuasionText>
          </S.ContentTextWrapper>
        </S.ContentWrap>
      </S.InnerWrap>
    </S.Container>
  );
};

export default SocialPersuasionUI;
